import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, data }) => {
  switch (type) {
    case types.CALCULATE_CHEM_RISK_LEVEL_FAILURE:
      return {
        title: t('message.title.error.calculate.chem.risk.level'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    case types.CALCULATE_ENV_RISK_FAILURE:
      return {
        title: t('message.title.error.calculate.env.risk'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };
    default:
      return false;
  }
};
